<template>
    <div class="content"  style="padding:0px 10px;padding-bottom:30px">
        <slot></slot>
    </div>
</template>
<script>
export default {
   
}
</script>
<style lang="scss" scoped>
.content{
    padding:0px 10px;
    position: fixed;
  
    top:6vw;;
    width:100%;
    height: 100%;
    bottom: 0px;
    left: 0px;
    right: 0px;
    overflow-y: auto;
}
</style>